// extracted by mini-css-extract-plugin
export default {"container":"Zq-z","ratingLayout":"_q-z","ratingLabel":"ar-z","nonInteractiveRatingLabel":"br-z"};